/**
 * @desc /查询箱码
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierBoxGaugeUpdateRecord.pageList.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/supplierBoxGaugeUpdateRecord/pageList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
